export default "__VITE_ASSET__Cp8btYGV__"